import { Component, OnInit, Input, ElementRef, QueryList, ViewChildren, Output, EventEmitter } from '@angular/core';
import { ItineraryService } from '../../shared/itinerary.service';
import { UserService } from '../../pages/com.usblick.common/auth/user.service';
import * as moment from 'moment';
import CssFilterConverter from 'css-filter-converter';
import { NotificationService } from 'app/shared/notifications/notification.service';
@Component({
  selector: 'usb-summary-reservation',
  templateUrl: './summary-reservation.component.html',
  styleUrls: ['./summary-reservation.component.scss']
})
export class SummaryReservationComponent implements OnInit {

  @Input() step:string;
  @Input() itineraryItems: any = [];
  @Input() itineraryTotal: any;
  @Input() itinerary:any;
  @Input() totalPasajeros: any;
  @Input() styleSidebar: any;
  @Input() currencies: any[];
  @Input() getClientsSettingAppBooking: any;
  @Input() currencyAgency: any;
  @Output() addFormEmitType = new EventEmitter();
   @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;
    @ViewChildren('icons_two', { read: ElementRef }) icons_two: QueryList<ElementRef>;
        @ViewChildren('icons_lugagge', { read: ElementRef }) icons_lugagge: QueryList<ElementRef>;

  totalTarifaNeta  :number = 0;
  totalTarifa  :number = 0;
  totalBlickoins = 0;
  dateItinerary:string = '';

  price: number;
  blickoins: number;
  totalCreditBlickoins: number;
  totalNetPriceBookingFreeTax: number;
  taxNightsPriceTotal: number;
  public taxSum: number = 0;
  public taxesExcluded: number = 0;
  public taxesSummable: { description?: string; amount?: number; included?: boolean }[] = [];
  public taxesNotSummable: { description?: string; amount?: number; currency?: string }[] = [];
  public currencyItinerary: string
  fontSizeAdjustments = { 4: 0, 6: -2, 9: -6 };
      filterColorIcon: any;
        buttonTextActive: string = '';

  constructor(public serviceItinerary: ItineraryService, public userService:UserService, private notificationService: NotificationService )
    {
    }

  ngOnInit() {

    const bookingFlow_sidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.dataTax(this.itineraryItems);
    this.dataTaxExcluded(this.itineraryItems);
    this.itineraryItems.forEach(item => {
      const destiny = this.itinerary.destination.find(element=> element.iata_code == item.destination.iata_code);
      item.cityame = destiny.destination_info.cityName;
      this.price = item.netPriceAgent;
      this.blickoins = Number(item.profility.blickoins);
      // console.log('blickoins', this.blickoins);
      this.totalCreditBlickoins = item.profility.creditBlickoins;
      // console.log('total Blickoins', this.totalBlickoins);
      this.totalNetPriceBookingFreeTax = item.optionNightsNetTotalFreeTax;
      this.taxNightsPriceTotal = item.taxNightsPriceTotal;
      this.totalNetPriceBookingFreeTax = this.itineraryItems.reduce((sum, item) => sum + parseFloat(item.optionNightsNetTotalFreeTax), 0);
      this.taxNightsPriceTotal =  this.itineraryItems.reduce((sum, item) => sum + parseFloat(item.taxNightsPriceTotal), 0);
    });

    this.totalTarifaNeta = this.itinerary.totalNetPriceBooking;
    this.totalTarifa  = this.itinerary.totalNetPriceAgent;
    this.totalBlickoins =  this.itinerary.totalBlickoins;
    this.totalCreditBlickoins = this.itinerary.totalCreditBlickoins;
    this.currencyItinerary = this.itineraryItems[0]?.currency;
    localStorage.setItem('totalNetReserved', this.itinerary.totalPriceByNetReserved);
    localStorage.setItem('totalReserved', this.itinerary.totalPriceByReserved);





    this.price = this.itineraryItems.reduce((sum, item) => sum + parseFloat(item.netPriceAgent), 0);
    this.blickoins = this.itineraryItems.reduce((sum, item) => sum + Number(item.profility.blickoins), 0);
    this.totalCreditBlickoins = this.itineraryItems.reduce((sum, item) => sum + Number(item.profility.creditBlickoins), 0);
  }

    private dataTaxExcluded(data: any) {
    // "Cargos" (CARGOS) son los impuestos NO incluidos en la tarifa, a pagar en destino.
    // Se dividen en dos grupos: los que se pueden convertir a la moneda de la agencia
    // (taxesSummable, suman a taxSum) y los que no se pueden convertir por no soportarse
    // su moneda (taxesNotSummable) — igual se pagan en destino, sólo que en su moneda original.
    this.taxesSummable = [];
    this.taxesNotSummable = [];
    this.taxesExcluded = 0;

    if (data && data.length > 0) {
      // Recorre cada producto en los datos
      data.forEach((product) => {
        // Verifica por categoría de hoteles para evitar conflictos con otras categorías y sus precios.
        if(product.categoryName == 'HOTELS'){
          // Verifica si hay taxes en el ítem
          if (product.room.pricing.taxes && Array.isArray(product.room.pricing.taxes)) {
            // Recorre cada impuesto en las taxes
            product.room.pricing.taxes.forEach((tax) => {
              // 'included' en false = cargo a pagar en destino (excluido de la tarifa).
              const isExcluded = typeof tax.included === 'boolean' && !tax.included;

              // El backend puede mandar el importe como string: se fuerza a number para evitar
              // concatenación de strings en las sumas de abajo.
              const taxAmount = Number(tax.amount);

              // Convierte el importe a la moneda de la agencia cuando es posible (included true o false).
              let convertedAmount: number | null = null;

              if (tax.currency === this.currencyAgency?.code) {
                convertedAmount = taxAmount;
              } else {
                const taxCurrency = this.currencies.find(c => c.code === tax.currency);

                if (taxCurrency) {
                  const taxBase = taxAmount / taxCurrency.rate;
                  convertedAmount = taxBase * this.currencyAgency?.rate;
                }
              }

              // taxSum suma todos los impuestos convertibles, estén o no incluidos en la tarifa.
              // if (convertedAmount !== null) {
              //   this.taxSum += convertedAmount;
              // }

              if (isExcluded) {
                // taxesExcluded suma solo los cargos (included false), en su importe original.
                this.taxesExcluded += taxAmount;

                if (convertedAmount !== null) {
                  this.taxesSummable.push({
                    description: tax.description, amount: convertedAmount, included: false
                  });
                } else {
                  // Moneda del impuesto no soportada: no se puede convertir ni sumar
                  // al total, pero igual corresponde pagarlo en destino.
                  this.taxesNotSummable.push({
                    description: tax.description, amount: taxAmount, currency: tax.currency
                  });
                }
              }
            });
          }
        }

      });
    }

    console.log(this.taxesExcluded)
    this.applyImageFilter();

  }


  private dataTax(data: any) {
    // "Cargos" (CARGOS) son los impuestos NO incluidos en la tarifa, a pagar en destino.
    // Se dividen en dos grupos: los que se pueden convertir a la moneda de la agencia
    // (taxesSummable, suman a taxSum) y los que no se pueden convertir por no soportarse
    // su moneda (taxesNotSummable) — igual se pagan en destino, sólo que en su moneda original.
    this.taxesSummable = [];
    this.taxesNotSummable = [];

    if (data && data.length > 0) {
      // Recorre cada producto en los datos
      data.forEach((product) => {
        // Verifica por categoría de hoteles para evitar conflictos con otras categorías y sus precios.
        if(product.categoryName == 'HOTELS'){
          // Verifica si hay taxes en el ítem
          if (product.room.pricing.taxes && Array.isArray(product.room.pricing.taxes)) {
            // Recorre cada impuesto en las taxes
            product.room.pricing.taxes.forEach((tax) => {
              // 'included' en false = cargo a pagar en destino (excluido de la tarifa).
              const isExcluded = typeof tax.included === 'boolean' && tax.included;

              // El backend puede mandar el importe como string: se fuerza a number para evitar
              // concatenación de strings en las sumas de abajo.
              const taxAmount = Number(tax.amount);

              // Convierte el importe a la moneda de la agencia cuando es posible (included true o false).
              let convertedAmount: number | null = null;

              if (tax.currency === this.currencyAgency?.code) {
                convertedAmount = taxAmount;
              } else {
                const taxCurrency = this.currencies.find(c => c.code === tax.currency);

                if (taxCurrency) {
                  const taxBase = taxAmount / taxCurrency.rate;
                  convertedAmount = taxBase * this.currencyAgency?.rate;
                }
              }

              // taxSum suma todos los impuestos convertibles, estén o no incluidos en la tarifa.
              if (convertedAmount !== null) {
                this.taxSum += convertedAmount;
              }

              if (isExcluded) {
                // taxesExcluded suma solo los cargos (included false), en su importe original.


                if (convertedAmount !== null) {
                  this.taxesSummable.push({
                    description: tax.description, amount: convertedAmount, included: false
                  });
                } else {
                  // Moneda del impuesto no soportada: no se puede convertir ni sumar
                  // al total, pero igual corresponde pagarlo en destino.
                  this.taxesNotSummable.push({
                    description: tax.description, amount: taxAmount, currency: tax.currency
                  });
                }
              }
            });
          }
        }

      });
    }
    // Formatea el resultado con dos decimales
    this.taxSum = parseFloat(this.taxSum.toFixed(2)) + ( this.taxesExcluded || 0);

    this.applyImageFilter();

  }



  setDateHead(date?:string) {
    if (date) {
      let dateSplit = date.split("-");
      return '' + dateSplit[2] + ' ' + moment().month(parseInt(dateSplit[1]) - 1).format('MMM-Y');
    }else{
      return '';
    }
  }


  // Ciudad + IATA de cada escala (todos los segmentos del tramo salvo el
  // último, cuyo arrival ya es el destino final, no una escala).
  getFlightStops(item: any): { city: string; airport: string }[] {
    const segments = item?.itinerary?.[0]?.options?.[0]?.segments || [];
    if (segments.length <= 1) {
      return [];
    }
    return segments.slice(0, -1).map((segment: any) => ({
      city: segment?.arrival?.city,
      airport: segment?.arrival?.airport,
    }));
  }

  verifyCityExist(i){

    if(this.itineraryItems[i-1]){

      if(this.itineraryItems[i-1].destination.iata_code ==  this.itineraryItems[i].destination.iata_code){

        return true;
      }else{
        return false;
      }
      //console.log("")
    }else{
      return false;
    }

  }

  extractNameTransport(form: any, type: string, itemPayload: any): string {
    switch(type) {
      case 'origin':
        switch(itemPayload.transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.name || form.hotel_name}`;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'city':
            return `${form.value}`;
        }
      case 'destination':
        switch(itemPayload.transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.name ||form.hotel_name}`;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'city':
            return `${form.value}`;
        }
    }
  }

      getTypeWay(typeWay: any): string {

    if(typeWay !== undefined) {
      return typeWay === 1 ? 'IDA' : 'VUELTA';
    } else {
      return '  ';
    }
  }

      getMessageFirstTime(pickupOrDropoff: any,input: string): string {

  let firstOrigin = {};
  let firstDestination = {};

  firstOrigin = input === 'origin' ? pickupOrDropoff : {};
  firstDestination = input === 'destination' ? pickupOrDropoff : {};

  let message: string = '';
  let messageFly: string = '';
  // const messageFly = 'Hora arribo del vuelo';
  if(input === 'origin') {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  } else {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  }

  const messageDestination = 'Hora pickup del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }

  if(message === '') {
    message = firstDestination && firstDestination['type'] === 'airport' ? messageFly : messageDestination;
  }

  return message

  }

     applyImageFilter() {
          const color = this.styleSidebar?.color;
          const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

          //Extraemos el literal en String de la conversión
          const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

          // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
          const colorRegex = /color\((.*)\)/;
          const colorMatch = tempFilterStr.match(colorRegex);
          const colorFilter = colorMatch ? colorMatch[1] : "";

          this.filterColorIcon = colorFilter;
          // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
          setTimeout(() => {
            this.icons_lugagge.forEach(icon => {
              icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 21px;`);
            });
            this.icons.forEach(icon => {
              icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 16px;`);
            });

             this.icons_two.forEach(icon => {
              icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 14px;`);
            });
           // console.log(this.filter);
          }, 100);
        }


          getNetTarifa() {
            let price = 0;
            // price = this.itinerary.totalNetPriceBooking ? this.itinerary.totalNetPriceBooking  : 0;
            price = this.calculateTotal('netPriceBookingFreeTax');
            return price;
          }


          getTotalTarifa() {
            let price = 0;
            //  price = this.itinerary.totalNetPriceAgent ? this.itinerary.totalNetPriceAgent  : 0;
            price = this.calculateTotal('netPriceAgent');
            return price;
          }

          getComission() {
            let comission = 0;
            comission =  this.calculateTotal('fee');
            // comission = this.itinerary.totalFee ? this.itinerary.totalFee  : 0;
            return comission
          }



private calculateTotal(fieldName: string): number {

    return this.serviceItinerary.calculateTotal(
                                                fieldName,
                                                this.itinerary,
                                                this.currencies,
                                                this.currencyAgency,
                                                'quote');

}

addForm(type: string): void {
  const validation = this.validatePassengerAddition(type);
  if (!validation.valid) {
    this.notificationService.info(validation.message);
    return;
  }
  this.addFormEmitType.emit(type);
}

private validatePassengerAddition(type: string): { valid: boolean, message?: string } {
  const typeConfig = {
    'adult': { limit: this.totalPasajeros.maxAdults, name: 'adultos' },
    'children': { limit: this.totalPasajeros.maxChildren, name: 'niños' }
  };

  const currentCount = this.totalPasajeros.paxes.filter(c => c.type === type).length;

  if (currentCount >= typeConfig[type].limit) {
    return {
      valid: false,
      message: `Ya eligió todos los pasajeros ${typeConfig[type].name} admitidos para esta reserva`
    };
  }

  return { valid: true };
}

getDurationTour(item): string {

  if(item.scheduling && Array.isArray(item.scheduling) && item.scheduling.length > 0) {
    return `${item.scheduling[0]?.duration?.value} ${item.scheduling[0]?.duration?.metric === 'HOURS' ? 'hs.' : 'min.'}`;
  }

  return '';
}

// private parseNumber(value:any):number{
//   if(value == null || value == '') return 0;

//   return parseFloat(String(value).replace(/\./g, '').replace(',', '.')) || 0;
// }

}
